import listActions from 'src/modules/tipoActivo/list/tipoActivoListActions';
import TipoActivoService from 'src/modules/tipoActivo/tipoActivoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TIPOACTIVO_DESTROY';

const tipoActivoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoActivoDestroyActions.DESTROY_STARTED,
      });

      await TipoActivoService.destroyAll([id]);

      dispatch({
        type: tipoActivoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoActivo.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/tipo-activo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoActivoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: tipoActivoDestroyActions.DESTROY_ALL_STARTED,
      });

      await TipoActivoService.destroyAll(ids);

      dispatch({
        type: tipoActivoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.tipoActivo.destroyAll.success'),
      );

      getHistory().push('/tipo-activo');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: tipoActivoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default tipoActivoDestroyActions;
